import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "Pages/PrivateRoute/AuthContext";
import { useToast } from "../../hooks/use-toast";

const Layout: React.FC = () => {
  const { isAuthenticated, companyName, logout } = useAuth();
    const [collapsed, setCollapsed] = useState<boolean>(false);

  const navigate = useNavigate();
  const { toast } = useToast();
  
  const handleLogout = () => {
    try {
      logout(); 
  
      toast({
        title: "Success",
        description: "Logged out successfully",
      });

      navigate("/", { replace: true });
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "Error",
        description: "Failed to log out. Please try again.",
        variant: "destructive",
      });
      navigate("/", { replace: true });
    }
  };

  return (
    <>
      {isAuthenticated && (
        <div className="user-info-bar">
          <div className="logo-container">
            <h2 style={{ fontWeight: "bolder", color: "white", fontSize: "30px" }}>
              LEEN
            </h2>
            <hr/>
          </div>
          {companyName && (
            <div className="d-flex align-items-center ms-auto">
              <span className="company-name">{companyName}</span>
              <button
                onClick={handleLogout}
                className="btn btn-link p-0 ms-3"
                style={{ color: "white", fontSize: "1.2rem" }}
                title="Log Out"
              >
                <i className="bi bi-box-arrow-right"></i>
              </button>
            </div>
          )}
        </div>
      )}


      <div className="container m-0 p-0 d-flex overflow-hidden">
        {isAuthenticated && (
          // <div className={`navbar-wrapper ${collapsed ? "w-[50px]" : "w-[250px]"}`} style={{ position: "fixed", top: "70px", bottom: 0, overflowY: "auto" }}>
          <div className="navbar-wrapper" style={{ position: "fixed", top: "70px",width: "250px", bottom: 0, overflowY: "auto" }}>
            {/* <button onClick={() => setCollapsed(!collapsed)} className="w-40 text-white">{collapsed ? "Expand" : "Collapse"}</button> */}
            <Navbar />
          </div>
        )}
<div style={{ marginLeft: isAuthenticated ? "250px" : "0", width: isAuthenticated ? "calc(100% - 250px)" : "100%", padding: "0" }}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
